import { QueryKey } from '@tanstack/react-query';

export const alimtalkQueryKeys = {
  /** 발송 유형(템플릿) 목록 */
  templateList: (params?: Record<string, unknown>): QueryKey => ['alimtalk', 'template', 'list', params ?? {}],

  /** 템플릿 상세 */
  templateDetail: (id: number): QueryKey => ['alimtalk', 'template', 'detail', id],
};
